import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Globe2, RefreshCw } from "lucide-react";

const FLAG = {
  FR: "🇫🇷", ES: "🇪🇸", BE: "🇧🇪", IT: "🇮🇹", NL: "🇳🇱", DE: "🇩🇪", PT: "🇵🇹",
  CH: "🇨🇭", AT: "🇦🇹", GB: "🇬🇧", IE: "🇮🇪", SE: "🇸🇪", NO: "🇳🇴", DK: "🇩🇰",
  FI: "🇫🇮", GR: "🇬🇷", PL: "🇵🇱", CZ: "🇨🇿", CA: "🇨🇦", US: "🇺🇸", AE: "🇦🇪",
  TR: "🇹🇷", AU: "🇦🇺",
};

const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return isNaN(d.getTime()) ? "—" : d.toLocaleDateString();
};

export default function AdminCountryCounts() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => {
    setBusy(true);
    api.get("/admin/radar/country-stats")
      .then((r) => setData(r.data))
      .catch(() => setData({ total: 0, countries: [] }))
      .finally(() => setBusy(false));
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const rows = data?.countries || [];

  return (
    <section className="mb-8 rounded-2xl border border-slate-200 bg-white p-6" data-testid="admin-country-counts">
      <div className="mb-4 flex items-center justify-between gap-3">
        <h2 className="flex items-center gap-2 font-display text-xl text-[#0F172A]">
          <Globe2 className="h-5 w-5 text-[#C6A87C]" /> Annonces réelles récupérées par pays
        </h2>
        <button onClick={load} disabled={busy} data-testid="admin-country-counts-refresh"
          className="inline-flex items-center gap-1.5 rounded-full border border-slate-300 px-3 py-1.5 text-xs font-medium text-slate-600 hover:bg-slate-50">
          <RefreshCw className={`h-3.5 w-3.5 ${busy ? "animate-spin" : ""}`} /> Actualiser
        </button>
      </div>

      {!data ? (
        <p className="text-sm text-slate-400">Chargement…</p>
      ) : rows.length === 0 ? (
        <div className="rounded-xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-500" data-testid="admin-country-counts-empty">
          Aucune annonce enregistrée pour le moment.
        </div>
      ) : (
        <>
          <p className="mb-4 text-sm text-slate-500">
            Total : <b className="text-[#0F172A]" data-testid="admin-country-counts-total">{data.total}</b> annonces réelles en base
          </p>
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
            {rows.map((c) => (
              <div key={c.country} data-testid={`admin-country-${c.country}`}
                className="rounded-xl border border-slate-200 bg-slate-50 p-4 transition-colors hover:border-[#C6A87C]/50">
                <div className="flex items-center gap-2">
                  <span className="text-xl leading-none">{FLAG[c.country] || "🌍"}</span>
                  <span className="text-sm font-medium text-slate-600">{c.name}</span>
                </div>
                <p className="mt-2 text-2xl font-bold tabular-nums text-[#0F172A]" data-testid={`admin-country-${c.country}-count`}>
                  {c.count}
                </p>
                <p className="mt-1 text-xs text-slate-400">Dernière : {fmtDate(c.last_seen)}</p>
              </div>
            ))}
          </div>
        </>
      )}
    </section>
  );
}
